module.exports = __webpack_public_path__ + "static/img/11.8dfbbd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/11.png
// module id = 4h4z
// module chunks = 0